// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N5d9","left":"styles_left__3blVZ"};